import React, {useState, useEffect} from 'react';
import "../styles/RoomRates.css"

const RoomRates = () => {
  const [rooms, setRooms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(null);
  const [newRate, setNewRate] = useState(0)
  const [message, setMessage] = useState("");

  useEffect(() => {
    const fetchRooms = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_URL_SCHEME}${process.env.REACT_APP_IP_ADDRESS}/api/fetchRoomDetails`,
          { method: "POST", headers: { "Content-Type": "application/json" } }
        );
        const data = await response.json();
        setRooms(data);
      } catch (error) {
        console.error("Error fetching rooms:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchRooms();
  }, []);

  const handleRateChange = async (type, newRate) => {
    setUpdating(type);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_URL_SCHEME}${process.env.REACT_APP_IP_ADDRESS}/api/updateRoomRate`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ type, amount: newRate }),
        }
      );
      const result = await response.json();

      if (result.success) {
        setMessage(result.message)
      } else {
        setMessage("Failed to update rate: " + result.message);
      }
    } catch (error) {
      console.error("Error updating rate:", error);
    } finally {
      setUpdating(null);
    }
  };

  if (loading) return <p>Loading rooms...</p>;

  return (
    <div className="admin-rates">
      <h2>Change Room Rates</h2>
      <div className="admin-room-cards">
        {rooms.length > 0 ? (
          rooms.map((room) => (
            <div key={room._id} className="admin-room-card">
              <img
                src={room.type === "Double Bed" ? "./images/Room.jpg" : "./images/Room1.jpg"}
                alt={room.type}
              />
              <h3>{room.type} Room</h3>
              <p>Beds: {room.beds}</p>
              <div className="rate-update">
                <span className="currency">₹</span>
                <input type="number" defaultValue={room.amount} onChange={(e)=>setNewRate(e.target.value)}/>
                <button className="rate-button" onClick={() => handleRateChange(room.type, newRate)}>Update Rate</button>
              </div>
              {updating === room.type && <p className="updating">Updating...</p>}
            </div>
          ))
        ) : (
          <p className="no-rooms">No rooms available</p>
        )}
      </div>
      {message ? <p className="no-rooms">{message}</p> : null }
    </div>
  );
}

export default RoomRates
